import { Component, Input,OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
// import { PowerAttributesService} from '../../services/power-attributes.service';
import { PowerCatalogService } from '../../services/power-catalog.service'
import { catchError,map } from 'rxjs/operators';
import * as tablePowerCatalogElementExtension from './power-catalog-element-extension';
import { PowerResponse} from '../../interfaces/beans.interface'
import { Observable, of } from 'rxjs';
import { HttpEventType, HttpResponse , HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-power-catalog-element',
  templateUrl: './power-catalog-element.component.html',
  styleUrls: ['./power-catalog-element.component.css']
})

export class PowerCatalogElementComponent implements OnInit{

  @Input() elements: any;
  @Input() url_path: string;
  @Input() element_settings: any;

  // settingsPowerCatalogElement = tablePowerCatalogElementExtension.settingsPowerCatalogElementExtension

  source: LocalDataSource;

  PowerAttributes: any[];
  // powerExtensions?: Observable<PowerResponse>; // Hold the observable
  powerCatalogData?: Observable<PowerResponse>;
  message = '';

  constructor(private powerCatalogService: PowerCatalogService){
    // this.getPowerExtensions();
  }

  ngOnInit(): void {
    this.powerCatalogData = this.powerCatalogService.getAll(this.url_path);
  }
  

  add_element(event: any){
    console.log("Add Element",event);
    this.powerCatalogService.add_element(this.url_path,event).subscribe(
      (event: any) => {
        console.log("event-any")
        if(event instanceof HttpResponse){
          console.log("Data added succesfully!")
        }
      },
      (err: any) => {
        // console.trace()
        // console.log(err);
        // this.progress = 0;

        if (err.error && err.error.message) {
          this.message = err.error.message;
        } else {
          this.message = 'Could Add data!';
        }

      });
  }
  
  delete_element(event: any){
    console.log("Delete Element",event);
  }

  edit_element(event: any){
    console.log("Edit Element",event);
  }
    

}
